import type { LiteralExpression } from '@trackback/widgets';
import { createNamedExpressionResolver } from '../types';

export const literalResolver = createNamedExpressionResolver<LiteralExpression>(
  'literal',
  (_parser, _options, onData, [value]) => onData.next(value)
);
